import classNames from "classnames";
import { ReactNode } from "react";
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from "@mui/material";
import styles from "./plain-tooltip.styles.module.scss";

const TOOLTIP_TRANSITION_DELAY = 300;
const TOOLTIP_LAUNCH_DELAY = 600;

export type PlainTooltipProps = {
  children: ReactNode | ReactNode[];
  title: ReactNode | ReactNode[];
  additionalProps?: Partial<MuiTooltipProps>;
  deactivate?: boolean;
  rootClassName?: string;
  isMasked?: boolean;
};
/**
 * @param isMasked content display in tooltip will be masked in amplitude analytics system - should be true for any names, emails, or other PII
 */
export const PlainTooltipComponent = ({
  children,
  title,
  additionalProps = {},
  deactivate = false,
  rootClassName = "",
  isMasked = false,
}: PlainTooltipProps) => {
  return (
    <MuiTooltip
      arrow={true}
      classes={{
        arrow: styles.arrow,
        tooltip: styles.tooltip,
        tooltipArrow: styles.tooltipArrow,
      }}
      disableFocusListener={deactivate}
      disableHoverListener={deactivate}
      disableTouchListener={deactivate}
      enterDelay={TOOLTIP_LAUNCH_DELAY}
      enterNextDelay={TOOLTIP_LAUNCH_DELAY}
      TransitionProps={{
        timeout: {
          appear: TOOLTIP_TRANSITION_DELAY,
          enter: TOOLTIP_TRANSITION_DELAY,
          exit: TOOLTIP_TRANSITION_DELAY,
        }
      }}
      title={<span data-amp-mask={isMasked ? "" : undefined} className={styles.text}>{title}</span>}
      {...additionalProps}
    >
      <div className={classNames(styles.wrapper, rootClassName)}>{children}</div>
    </MuiTooltip>
  );
};
